//  SPLASH IMAGE FADE
//  SPLASH IMAGE FADE
//  SPLASH IMAGE FADE
const normals = Array.from(document.querySelectorAll(".splash-normal"));
const lightens = Array.from(document.querySelectorAll(".splash-lighten"));
const splashCover = document.querySelector("[data-splash-cover]");
const splashLogo = document.querySelector("[data-splash-logo]");
let coverFailSafeTimer = null;

const hideSplashCover = () => {
  if (!splashCover) return;
  if (splashCover.dataset.hidden === "true") return;
  if (coverFailSafeTimer) {
    clearTimeout(coverFailSafeTimer);
    coverFailSafeTimer = null;
  }
  splashCover.dataset.hidden = "true";
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      splashCover.style.transition = "opacity 220ms ease-out";
      splashCover.style.opacity = "0";
      const removeCover = () => {
        if (splashCover.isConnected) splashCover.remove();
      };
      splashCover.addEventListener("transitionend", removeCover, {
        once: true,
      });
      setTimeout(removeCover, 320);
    });
  });
};

if (normals.length > 0 && lightens.length > 0) {
  if (splashCover) {
    // Hard safety so cover can never block indefinitely.
    coverFailSafeTimer = setTimeout(() => {
      hideSplashCover();
    }, 7000);
  }

  const total = Math.min(normals.length, lightens.length);
  const initialStartDelay = 3800; // delay before switch from img0 to img1 also in second loop
  const imageNextImageDelay = 5500; // switch to next image; longer creates a pause where image is full visible
  const fadeDurationNormal = 300; // duration of the fade transition from normal to lighten, bit more than the fadeDuration for connected feel
  const fadeDuration = 400; // duration of the fade transition from lighten to the next image, roughly half of the imageNextImageDelay
  let deferredMediaActivated = false;

  const setFadeTransitionNormal = (el) => {
    el.style.transition = `opacity ${fadeDurationNormal}ms ease-out`;
  };
  const setInitialOpacity = (el) => {
    el.style.opacity = `1`;
  };
  const setFadeTransition = (el) => {
    el.style.transition = `opacity ${fadeDuration}ms ease-out`;
  };

  const getWrapper = (el) => el.closest("picture") || el;
  const normalWraps = normals.map(getWrapper);
  const lightenWraps = lightens.map(getWrapper);
  let firstImageReady = false;
  let logoReady = false;
  let navReady = !!window.__navPositionReady;
  const maybeHideSplashCover = () => {
    if (firstImageReady && logoReady && navReady) {
      hideSplashCover();
    }
  };
  if (!navReady) {
    window.addEventListener(
      "nav-position-ready",
      () => {
        navReady = true;
        maybeHideSplashCover();
      },
      { once: true },
    );
  }
  const markLogoReady = () => {
    logoReady = true;
    maybeHideSplashCover();
  };
  if (!splashLogo || getComputedStyle(splashLogo).display === "none") {
    logoReady = true;
  } else if (splashLogo.complete && splashLogo.naturalHeight !== 0) {
    logoReady = true;
  } else {
    splashLogo.addEventListener("load", markLogoReady, { once: true });
    splashLogo.addEventListener("error", markLogoReady, { once: true });
  }
  const activateDeferredMedia = () => {
    if (deferredMediaActivated) return;
    deferredMediaActivated = true;
    document
      .querySelectorAll("picture[data-deferred-media]")
      .forEach((picture) => {
        picture.querySelectorAll("source[data-srcset]").forEach((source) => {
          source.setAttribute("srcset", source.dataset.srcset || "");
          source.removeAttribute("data-srcset");
        });
        const img = picture.querySelector("img[data-src]");
        if (img) {
          img.setAttribute("src", img.dataset.src || "");
          img.removeAttribute("data-src");
        }
        picture.removeAttribute("data-deferred-media");
      });
  };

  // Reveal hidden images only after the top image has loaded
  const topImage = normals[0];
  const revealHiddenImages = () => {
    activateDeferredMedia();
    // Skip the first image (index 0) - it's already visible
    const hiddenImages = [...normals.slice(1), ...lightens.slice(1)];
    const hiddenWraps = [...normalWraps.slice(1), ...lightenWraps.slice(1)];

    [...hiddenImages, ...hiddenWraps].forEach((el) => {
      el.style.transition = "none";
      el.style.opacity = "1";
      void el.offsetHeight; // force reflow
    });

    // Also ensure first lighten is visible (it shares z-index layer with first normal)
    lightens[0].style.transition = "none";
    lightens[0].style.opacity = "1";
    lightenWraps[0].style.transition = "none";
    lightenWraps[0].style.opacity = "1";

    // Then apply fade transitions to all images
    setTimeout(() => {
      normals.forEach(setFadeTransitionNormal);
      setInitialOpacity(normals[0]);
      lightens.forEach(setFadeTransition);
      firstImageReady = true;
      maybeHideSplashCover();
    }, 50);
  };

  // Check if already loaded (cached) or wait for load event
  if (topImage.complete && topImage.naturalHeight !== 0) {
    revealHiddenImages();
  } else {
    topImage.addEventListener("load", revealHiddenImages, { once: true });
    topImage.addEventListener(
      "error",
      () => {
        firstImageReady = true;
        maybeHideSplashCover();
      },
      { once: true },
    );
  }
  [...normalWraps, ...lightenWraps].forEach((wrap) => {
    if (!wrap.dataset.origZ) {
      wrap.dataset.origZ = getComputedStyle(wrap).zIndex;
    }
  });

  const resetZIndices = () => {
    [...normalWraps, ...lightenWraps].forEach((wrap) => {
      const orig = wrap.dataset.origZ;
      if (orig && orig !== "auto") {
        wrap.style.zIndex = orig;
      } else {
        wrap.style.removeProperty("z-index");
      }
    });
  };

  const resetVisibility = () => {
    resetZIndices();
    normals.forEach((el) => {
      el.style.transition = "none";
      el.style.opacity = "1";
      void el.offsetHeight;
      setFadeTransitionNormal(el);
    });
    lightens.forEach((el) => {
      el.style.transition = "none";
      el.style.opacity = "1";
      void el.offsetHeight;
      setFadeTransition(el);
    });
  };

  const revealFirstBelowLast = () => {
    const firstNormal = normals[0];
    const firstLighten = lightens[0];
    const lastNormalWrap = normalWraps[total - 1];
    const firstNormalWrap = normalWraps[0];
    const firstLightenWrap = lightenWraps[0];
    const lastNormalZ = parseInt(getComputedStyle(lastNormalWrap).zIndex, 10);
    const zBase = Number.isFinite(lastNormalZ) ? lastNormalZ : 0;

    firstNormalWrap.style.zIndex = String(zBase - 2);
    firstLightenWrap.style.zIndex = String(zBase - 1);

    firstNormal.style.transition = "none";
    firstNormal.style.opacity = "1";
    void firstNormal.offsetHeight;
    setFadeTransitionNormal(firstNormal);

    firstLighten.style.transition = "none";
    firstLighten.style.opacity = "1";
    void firstLighten.offsetHeight;
    setFadeTransition(firstLighten);
  };

  const runCycle = () => {
    const startDelay = initialStartDelay;
    for (let i = 0; i < total; i++) {
      const normal = normals[i];
      const lighten = lightens[i];
      const baseDelay = i * imageNextImageDelay;
      const isLast = i === total - 1;

      setTimeout(() => {
        normal.style.opacity = "0";
      }, baseDelay + startDelay);

      if (isLast) {
        const revealLead = 100;
        const revealDelay = Math.max(0, baseDelay + startDelay - revealLead);
        setTimeout(() => {
          revealFirstBelowLast();
        }, revealDelay);
      }

      setTimeout(
        () => {
          lighten.style.opacity = "0";
        },
        baseDelay + startDelay + fadeDuration,
      );
    }

    const resetDelay =
      (normals.length - 1) * imageNextImageDelay +
      startDelay +
      fadeDuration +
      fadeDuration;
    // console.log(`resetDelay: ${resetDelay}`);
    setTimeout(() => {
      resetVisibility();
      runCycle();
    }, resetDelay);
  };

  runCycle();
} else {
  // No splash images: don't block the page if cover exists.
  hideSplashCover();
}
